module.exports = __webpack_public_path__ + "static/media/acumen_commverge.f8a72d61.png";